import { KeyValuePair } from '../../../TCSMApp/pages/arc/models/arc-epi-props';
import { ImageBlock } from './ecd-block-models';

export interface EcdContentPropsState<TProps> {
	contentLoaded: boolean;
	epiContent: TProps;
}

export interface EcdSiteSettingsState {
	siteSettingsLoaded: boolean;
	siteSettings: SiteSettingsProps;	
}

export interface EcdClergySettingsState {
	clergySettingsLoaded: boolean;	
	clergySettings: EcdClergySettingsProps;		
}

export interface EcdParishSettingsState {
	parishSettingsLoaded: boolean;		
	parishSettings: EcdParishSettingsProps,	
}

export enum EcdEpiApiActionTypes {
	SET_EPI_PROPS = 'SET_EPI_PROPS',
	SET_SITE_SETTINGS_PROPS = 'SET_SITE_SETTINGS_PROPS',
	SET_LABEL_EPI_PROPS = 'SET_LABEL_EPI_PROPS',	
	SET_EPI_PAGE_DATA = 'SET_EPI_PAGE_DATA',
	UNLOAD_EPI_PAGE_DATA = 'UNLOAD_EPI_PAGE_DATA',	
	SET_CLERGY_SETTINGS_PROPS = 'SET_CLERGY_SETTINGS_PROPS',
	SET_PARISH_SETTINGS_PROPS = 'SET_PARISH_SETTINGS_PROPS',
	SET_MAIL_SETTINGS_PROPS = 'SET_MAIL_SETTINGS_PROPS',
}

export interface ApiErrorMessageMap {
	messageCode: string,
	message: string,
}

export interface EcdEpiProps {
	pageTitle: string;
	apiResponseMessages?: ApiErrorMessageMap[];
}

export interface SuccessMessageWithNBA {
	title: string,
	message: string,
}

export interface SiteSettingsProps {
	signInPage: string;
	error400: string;
	error401Title: string;
	error401Message: string;
	error403Title: string;
	error403Message: string;
	error401403HomeLinkText: string;
	error404Title: string;
	error404: string;
	error500: string;
	errorTimeout: string;
	defaultError: string;	
	logo?: ImageBlock;
	externalLinkModalMessage: string;
	externalLinkModalCancelButtonText: string;
	externalLinkModalContinueButtonText: string;
	remoteSupportLinkModalMessage: string;
	tcsmFatalErrorMessage?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultEcdSiteSettingsProps: SiteSettingsProps = {
    signInPage: '',
    error400: '',
    error401Message: '',
    error401Title: '',
    error403Title: '',
    error401403HomeLinkText: '',
    error403Message: '',
    error404Title: '',
    error404: '',
    error500: '',
    errorTimeout: '',
    defaultError: '',
    externalLinkModalContinueButtonText: '',
    externalLinkModalCancelButtonText: '',
    externalLinkModalMessage: '',
    remoteSupportLinkModalMessage: '',
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultSiteSettingsState: EcdSiteSettingsState = {
	siteSettingsLoaded: false,
	siteSettings: DefaultEcdSiteSettingsProps,
};

export interface ECDNavigationLink {
	linkText : string;
	linkUrl: string;
	external: boolean;
}

export interface EcdClergySettingsProps {  
	// -- Search
	pageTitle: string;
	advancedSearchTitle: string;
	formInstructionMessage: string;
	advancedFormInstructionMessage: string;
	nameLabel: string;	
	firstNameLabel: string;
	firstMiddleNameLabel: string;
	lastNameLabel: string;
	cityOrCountryLabel: string;
	zipCodeLabel: string;
	canonicalResidenceLabel: string;
	bishopLabel: string;
	termsOfUseMessage: string;
	clearFormButton: string;
	submitFormButton: string;
	advancedSearchButton: string;
	backButton: string;
	newSearchButton: string;
	modifySearchButton: string;
	postFormMessage: string;
	viewAllResultsTemplate: string;  	
	cityLabel: string;
	stateLabel: string;
	countryLabel: string;	
	noResultsMessage: string;
	noResultsAutocompleteMessage: string;
	orderByMapping: KeyValuePair[]
	orderByLabel: string;
	recordsFoundLabel: string;
	fieldOnlySpacesMessage?: string;
	searchResultTitle: string;
	listingUSTitle: string;
	listingInternationalTitle: string;

	// -- Search Advanced	
	bishopYesItem: string;
	bishopNoItem: string
	canonicalResidanceMapping: KeyValuePair[];

	// -- Detail
	sendEmailLabel: string;
	publishedAddressTitle: string;
	publishedAddressEmptyMessage: string;
	canonicalResidenceTitle: string;
	canonicalResidenceEmptyMessage: string;
	principalPositionsTitle: string;
	principalPositionsEmptyMessage: string;
	parishInstitutionsTitle: string;
	parishInstitutionsEmptyMessage: string;
	ordinationInformationTitle: string;
	ordinationInformationEmptyMessage: string;
	receptionInformationTitle: string;
	dioceseDetailLabel: string;
	bishopDetailLabel: string;
	diaconalDateDetailLabel: string;
	priestingDateDetailLabel: string;
	consecrationDateDetailLabel: string;
	consecratorsDetailLabel: string;
	dateDetailLabel: string;
	transferalInformationTitle: string;
	transferalDateDetailLabel: string;
	transferalBishopDetailLabel: string;
	transferalProvidenceDetailLabel: string;
	receptionDateDetailLabel: string;
	receptionFromDetailLabel: string;
	receptionOrdenDetailLabel: string;
	receptionBishopDetailLabel: string;	
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  export const DefaultEcdClergySettingsProps: EcdClergySettingsProps = {
	  pageTitle: '',
	  advancedSearchTitle: '',
	  formInstructionMessage: '',
	  nameLabel: '',
	  firstNameLabel: '',
	  lastNameLabel: '',
	  cityOrCountryLabel: '',
	  zipCodeLabel: '',
	  canonicalResidenceLabel: '',
	  bishopLabel: '',
	  termsOfUseMessage: '',
	  clearFormButton: '',
	  submitFormButton: '',
	  advancedSearchButton: '',
	  postFormMessage: '',
	  viewAllResultsTemplate: '',
	  firstMiddleNameLabel: '',
	  cityLabel: '',
	  countryLabel: '',
	  backButton: '',
	  newSearchButton: '',
	  modifySearchButton: '',
	  stateLabel: '',
	  noResultsMessage: '',
	  sendEmailLabel: '',
	  publishedAddressTitle: '',
	  publishedAddressEmptyMessage: '',
	  canonicalResidenceTitle: '',
	  canonicalResidenceEmptyMessage: '',
	  principalPositionsTitle: '',
	  principalPositionsEmptyMessage: '',
	  parishInstitutionsTitle: '',
	  parishInstitutionsEmptyMessage: '',
	  ordinationInformationTitle: '',
	  ordinationInformationEmptyMessage: '',
	  transferalInformationTitle: '',
	  dioceseDetailLabel: '',
	  bishopDetailLabel: '',
	  diaconalDateDetailLabel: '',
	  priestingDateDetailLabel: '',
	  dateDetailLabel: '',
	  consecrationDateDetailLabel: '',
	  consecratorsDetailLabel: '',
	  receptionInformationTitle: '',
	  transferalDateDetailLabel: '',
	  transferalBishopDetailLabel: '',
	  transferalProvidenceDetailLabel: '',
	  receptionDateDetailLabel: '',
	  receptionFromDetailLabel: '',
	  receptionOrdenDetailLabel: '',
	  receptionBishopDetailLabel: '',
	  bishopYesItem: '',
	  bishopNoItem: '',
	  canonicalResidanceMapping: [],
	  recordsFoundLabel: '',
	  orderByMapping: [],
	  orderByLabel: '',
	  advancedFormInstructionMessage: '',
	  searchResultTitle: '',
	  listingUSTitle: '',
	  listingInternationalTitle: '',
	  noResultsAutocompleteMessage: '',
  };

  export interface EcdParishSettingsProps {  
	// -- Search
	pageTitle: string;	
	formInstructionMessage: string;
	nameLabel: string;	
	parishTypeLabel: string;	
	cityOrCountryLabel: string;
	zipCodeLabel: string;	
	termsOfUseMessage: string;
	clearFormButton: string;
	submitFormButton: string;	
	backButton: string;
	newSearchButton: string;
	modifySearchButton: string;
	postFormMessage: string;
	viewAllResultsTemplate: string;  	
	noResultsMessage: string;
	noResultsAutocompleteMessage: string;
	parishTypeMapping: KeyValuePair[];
	orderByMapping: KeyValuePair[]
	orderByLabel: string;
	recordsFoundLabel: string;
	fieldOnlySpacesMessage?: string;
	searchResultTitle: string;
	mapItTitle: string;

	// -- Detail
	sendEmailLabel: string;
	emailEmptyMessage: string;
	websiteEmptyMessage: string;
	addressTitle: string;
	addressEmptyMessage: string;
	recordTypeTitle: string;
	recordTypeEmptyMessage: string;
	dioceseTitle: string;
	dioceseEmptyMessage: string;
	websiteEmailTitle: string;
	websiteEmailEmptyMessage: string;
	phoneTitle: string;
	phoneEmptyMessage: string;
	faxTitle: string;
	faxEmptyMessage: string;
	parishClergyTitle: string;	
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  export const DefaultEcdParishSettingsProps: EcdParishSettingsProps = {
	  pageTitle: '',
	  formInstructionMessage: '',
	  nameLabel: '',
	  parishTypeLabel: '',
	  cityOrCountryLabel: '',
	  zipCodeLabel: '',
	  termsOfUseMessage: '',
	  clearFormButton: '',
	  submitFormButton: '',
	  backButton: '',
	  newSearchButton: '',
	  modifySearchButton: '',
	  postFormMessage: '',
	  viewAllResultsTemplate: '',
	  noResultsMessage: '',
	  parishTypeMapping: [],
	  sendEmailLabel: '',
	  addressTitle: '',
	  addressEmptyMessage: '',
	  recordTypeTitle: '',
	  recordTypeEmptyMessage: '',
	  dioceseTitle: '',
	  dioceseEmptyMessage: '',
	  websiteEmailTitle: '',
	  websiteEmailEmptyMessage: '',
	  phoneTitle: '',
	  phoneEmptyMessage: '',
	  faxTitle: '',
	  faxEmptyMessage: '',
	  parishClergyTitle: '',
	  emailEmptyMessage: '',
	  websiteEmptyMessage: '',
	  orderByMapping: [],
	  orderByLabel: '',
	  recordsFoundLabel: '',
	  searchResultTitle: '',
	  mapItTitle: '',
	  noResultsAutocompleteMessage: '',
  };

// eslint-disable-next-line @typescript-eslint/naming-convention
 export const DefaultEcdClergySettingsState: EcdClergySettingsState = {
	clergySettingsLoaded: false,
	clergySettings: DefaultEcdClergySettingsProps,		
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultEcdParishSettingsState: EcdParishSettingsState = {
	parishSettingsLoaded: false,	
	parishSettings: DefaultEcdParishSettingsProps,	
};

export interface EcdMailSettingsProps {  	
	pageTitle: string;	
	formInstructionMessage: string;
	nameLabel: string;	
	emailLabel: string;	
	toLabel: string;
	messageLabel: string;	
	clearFormButton: string;
	submitFormButton: string;
	homeButton: string;		
	backButton: string;			
	emailFormatError: string;
	nameFormatError: string;
	messageSizeError: string;
	requiredFieldErrorTemplate: string;
	emailSentMessage: string;
	recaptchaSiteKey: string;
	emailSubject: string;
	emailBodyTemplate: string;	
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultEcdMailSettingsProps: EcdMailSettingsProps = {
	pageTitle: '',
	formInstructionMessage: '',
	nameLabel: '',
	emailLabel: '',
	toLabel: '',
	messageLabel: '',
	clearFormButton: '',
	submitFormButton: '',
	homeButton: '',
	backButton: '',
	emailFormatError: '',
	requiredFieldErrorTemplate: '',
	emailSentMessage: '',
	recaptchaSiteKey: '',
	emailSubject: '',
	emailBodyTemplate: '',
	nameFormatError: '',
	messageSizeError: '',	
};

export interface EcdMailSettingsState {
	mailSettingsLoaded: boolean;		
	mailSettings: EcdMailSettingsProps,	
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DefaultEcdMailSettingsState: EcdMailSettingsState = {
	mailSettingsLoaded: false,	
	mailSettings: DefaultEcdMailSettingsProps,	
};